import { documentReducer } from '@documents/reducer/documents.reducer';
import { gridViewReducer } from '@shared/store/reducers/grid-view.reducer';
import { investigatorReducer } from '@shared/store/reducers/investigator.reducer';
import { roleReducer } from '@shared/store/reducers/role.reducers';
import { siteWorkspaceReducer } from '@shared/store/reducers/siteWorkspace.reducer';
import { userRoleReducer } from '@shared/store/reducers/user-role.reducer';
import { userReducer } from '@shared/store/reducers/user.reducer';
import {
  workspaceQuestionnaireReducers,
  workspaceReducers,
  workspaceStudyReducers,
  workspaceTypeReducers,
} from '@shared/store/reducers/workspace.reducers';
import { webSocketReducer } from '../websocket/redux/websocket.reducer';
import { STUDY_FEATURE_KEY, studyReducer } from '@data-access/studies/reducer';
import { SITE_FEATURE_KEY, sitesReducer } from '@data-access/sites/reducer';
import { HOLIDAYSREDUCER } from '../setup/workspace/data-access/reducers/holiday.reducer';
import { CIRREDUCER } from '../setup/workspace/data-access/reducers/cir.reducer';
import { assignmentReducer } from '@data-access/assignment/reducers/assignment.reducers';
import { talkdeskReducer } from '@data-access/talk-desk';
import { ROLES_REDUCER } from '@data-access/roles';

/**
 *
 * Main reason for provide StoreModules is to keep the store imports clean
 * and isolated. So at any point if we have to update or
 * remove any dependency we can just do it here.
 *
 * Just for readablity purpose we don't want overwhelm app.module
 * with import statements
 */

export const provideStoreModules = () => {
  return {
    [SITE_FEATURE_KEY]: sitesReducer,
    [STUDY_FEATURE_KEY]: studyReducer,
    assignment: assignmentReducer,
    cir: CIRREDUCER,
    documents: documentReducer,
    gridView: gridViewReducer,
    holidays: HOLIDAYSREDUCER,
    investigator: investigatorReducer,
    role: roleReducer,
    roles: ROLES_REDUCER,
    siteWorkspace: siteWorkspaceReducer,
    talkdesk: talkdeskReducer,
    user: userReducer,
    userRole: userRoleReducer,
    websocket: webSocketReducer,
    workspaceId: workspaceReducers,
    workspaceQuestionnaireId: workspaceQuestionnaireReducers,
    workspaceStudyId: workspaceStudyReducers,
    workspaceTypeId: workspaceTypeReducers,
  };
};
